import React from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import RosterApi from './RosterApiClient';
import dayjs from './RosterDayJS';
import { Subtract } from 'utility-types';

export interface WithData {
    loading: boolean;
    data: any | null;
}

export const withData = <P extends WithData>(WrappedComponent: React.ComponentType<P>, msal: PublicClientApplication) => {
    return class extends React.Component<Subtract<P & { startDate: Date}, WithData>, WithData> {
        private readonly api: RosterApi = new RosterApi(msal);

        constructor(props: P & { startDate: Date }) {
            super(props);
            this.state = { loading: true, data: null };
        }

        componentDidMount() {
            return this.fetchData(this.props.startDate);
        }

        componentDidUpdate(previous: { startDate: Date }) {
            if (previous.startDate.getTime() !== this.props.startDate.getTime()) {
                return this.fetchData(this.props.startDate);
            }
        }

        private fetchData(startDate: Date) {
            return this.api.getRoster(startDate, dayjs(startDate).add(7, 'd').toDate())
                .then((data) => this.setState({ loading: false, data }))
                .catch(console.log);
        }

        render() {
            return <WrappedComponent {...this.props as P} loading={this.state.loading} data={this.state.data}  />
        }
    }
}